// The dashboard's sign-out. Only an Auth0 tenant (bootstrap auth_method set; App.js then wraps the
// layout in <Auth0Provider>) has an Auth0 session to end. A password tenant has no provider, and
// useAuth0()'s logout is then a stub that throws "You forgot to wrap your component in
// <Auth0Provider>" — after the local logout already ran, so the only effect was a Sentry event.
// The Auth0 redirect waits for logout(): it first deletes the session token on the backend, a request that
// navigating away would cancel.
export async function signOut({ authMethod, logout, auth0Logout, returnTo = window.location.origin }) {
    // Read before logout(), which may clear the bootstrap that holds auth_method.
    const auth0 = !!authMethod;
    await logout();
    if (auth0) auth0Logout({ logoutParams: { returnTo } });
}
